import { ITINERARIES_ITEM_TYPES } from '../../../../../../../constants';
import { SHARE_TYPE } from '../../constants';

export const locales = {
  info: {
    in: {
      [ITINERARIES_ITEM_TYPES.ITINERARY]: {
        for: {
          [SHARE_TYPE.CLIENT]:
            'When shared via email, the link is sent to the recipient’s email. If they have already downloaded the Travel Portal app & registered using the same email address, it will automatically appear in their app too.',
          [SHARE_TYPE.AGENT]:
            'When shared via email, the link is sent to the recipient’s email. If they have already downloaded the Travel Portal app & registered using the same email address, it will automatically appear in their app too.',
        },
      },
      [ITINERARIES_ITEM_TYPES.LOOKBOOK]: {
        for: {
          [SHARE_TYPE.CLIENT]:
            'When shared via email, the link is sent to the recipient’s email. If they have already downloaded the Travel Portal app & registered using the same email address, it will automatically appear in their app too.',
          [SHARE_TYPE.AGENT]:
            'When shared via email, the link is sent to the recipient’s email. If they have already downloaded the Travel Portal app & registered using the same email address, it will automatically appear in their app too.',
        },
      },
      [ITINERARIES_ITEM_TYPES.GUEST_PORTAL]: {
        for: {
          [SHARE_TYPE.CLIENT]:
            'Once you invite someone to a Guest Portal, the link is sent to their email and also automatically added to their Travel Portal App dashboard. The email address must match the one registered with the app.',
          [SHARE_TYPE.AGENT]:
            'Once you invite someone to a Guest Portal, the link is sent to their email and also automatically added to their Travel Portal App dashboard. The email address must match the one registered with the app.',
        },
      },
    },
  },
  shareTypeInfo: {
    in: {
      [ITINERARIES_ITEM_TYPES.ITINERARY]: {
        for: {
          [SHARE_TYPE.AGENT]:
            'An editable copy will be added to their Safari Portal dashboard <i><b>if they are a Safari Portal user</b></i>.<br />' +
            '<i>Note: You won’t see their edits, and they won’t see any new edits you make after sharing.</i><br /><br />' +
            'For non-Safari Portal users, they’ll receive a shareable digital link.',
        },
      },
      [ITINERARIES_ITEM_TYPES.LOOKBOOK]: {
        for: {
          [SHARE_TYPE.AGENT]:
            'An editable copy will be added to their Safari Portal dashboard <i><b>if they are a Safari Portal user</b></i>.<br />' +
            '<i>Note: You won’t see their edits, and they won’t see any new edits you make after sharing.</i><br /><br />' +
            'For non-Safari Portal users, they’ll receive a shareable digital link.',
        },
      },
    },
  },
  body: {
    in: {
      [ITINERARIES_ITEM_TYPES.ITINERARY]: {
        for: {
          [SHARE_TYPE.CLIENT]:
            'I’m delighted to share this exciting travel plan with you. \n\n' +
            'I hope you enjoy the proposal and will look forward to your feedback.',
          [SHARE_TYPE.AGENT]:
            'I’m delighted to share this exciting travel plan with you. \n\n' +
            'I hope you enjoy the proposal and will look forward to your feedback.',
          [SHARE_TYPE.FRIEND]:
            'I’m delighted to share this exciting travel plan with you. \n\n' +
            'I hope you enjoy the proposal and will look forward to your feedback.',
        },
      },
      [ITINERARIES_ITEM_TYPES.LOOKBOOK]: {
        for: {
          [SHARE_TYPE.CLIENT]:
            'I’m delighted to share this exciting travel plan with you. \n\n' +
            'I hope you enjoy the proposal and will look forward to your feedback.',
          [SHARE_TYPE.AGENT]:
            'I’m delighted to share this exciting travel plan with you. \n\n' +
            'I hope you enjoy the proposal and will look forward to your feedback.',
          [SHARE_TYPE.FRIEND]:
            'I’m delighted to share this exciting travel plan with you. \n\n' +
            'I hope you enjoy the proposal and will look forward to your feedback.',
        },
      },
      [ITINERARIES_ITEM_TYPES.GUEST_PORTAL]: {
        for: {
          [SHARE_TYPE.CLIENT]:
            'I am pleased to share your custom travel portal with you.\n\n' +
            'If you like, you can download the Travel Portal app from the App Store or Google Play store. As long as you register using this same email address, you will be able to access everything from there automatically.\n\n' +
            'Let me know if you have any questions.\n\n',
          [SHARE_TYPE.AGENT]:
            'I am pleased to share this custom travel portal with you. \n\n' +
            'Once you log into the portal, you will be able to share with your clients. On a desktop, you can do this by clicking the + person icon in the top right hand corner of the screen.\n\n' +
            'If you like, you can download the Travel Portal app from the App Store or Google Play store. As long as you register using this same email address, you will be able to access everything from there automatically.\n\n' +
            'To share the guest portal with your clients from the app, click the ‘Guest Portal’ button and then ‘Share’ from the three dots at the top right.\n\n' +
            'Let me know if you have any questions.',
          [SHARE_TYPE.FRIEND]:
            'I am pleased to share your custom travel portal with you.\n\n' +
            'If you like, you can download the Travel Portal app from the App Store or Google Play store. As long as you register using this same email address, you will be able to access everything from there automatically.\n\n' +
            'Let me know if you have any questions.\n\n',
        },
      },
    },
  },
  subject: {
    in: {
      [ITINERARIES_ITEM_TYPES.ITINERARY]: {
        for: {
          [SHARE_TYPE.CLIENT]: 'Your Custom Travel Plan',
          [SHARE_TYPE.AGENT]: 'Your Custom Travel Plan',
          [SHARE_TYPE.FRIEND]: 'Your Custom Travel Plan',
        },
      },
      [ITINERARIES_ITEM_TYPES.LOOKBOOK]: {
        for: {
          [SHARE_TYPE.CLIENT]: 'Your Custom Travel Plan',
          [SHARE_TYPE.AGENT]: 'Your Custom Travel Plan',
          [SHARE_TYPE.FRIEND]: 'Your Custom Travel Plan',
        },
      },
      [ITINERARIES_ITEM_TYPES.GUEST_PORTAL]: {
        for: {
          [SHARE_TYPE.CLIENT]: 'Guest Portal Access Link for Upcoming Travel 🌎',
          [SHARE_TYPE.AGENT]: 'Guest Portal Access Link for Upcoming Travel 🌎',
          [SHARE_TYPE.FRIEND]: 'Guest Portal Access Link for Upcoming Travel 🌎',
        },
      },
    },
  },
};
